import React from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

function AuthLayout() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return null;
  if (user) {
    const params = new URLSearchParams(location.search);
    const from = params.get('from') || '/dashboard';
    return <Navigate to={from} replace />;
  }

  return (
    <div className="auth-shell">
      <main className="auth-main">
        <Outlet />
      </main>
    </div>
  );
}

export default AuthLayout;
